const projectMenu = [
  {
    System: 'PROJECT',
    isActive: true,
    menu: [
      { is_header: true, title: 'ProjectManagement', isActive: true },

      {
        path: '/PROJECT/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },
      {
        path: '/PROJECT/ProjectOverview',
        icon: 'bi bi-speedometer2',
        title: 'نظرة عامة',
        isActive: true
      },

      { is_header: true, title: 'Projects', isActive: true },

      {
        path: '/PROJECT/ProjectsList',
        icon: 'fas fa-folder-tree',
        title: 'ProjectsList',
        // permission: 'ProjViewList',
        isActive: true
      },
      {
        path: '/PROJECT/ProjectsList2',
        icon: 'fas fa-folder-tree',
        title: 'ProjectsList2',
        // permission: 'ProjViewList',
        isActive: true
      },
      {
        path: '/PROJECT/AddProject',
        icon: 'fas fa-plus-circle',
        title: 'AddProject',
        // permission: 'ProjAddProject',
        isActive: true
      },

      { is_header: true, title: 'Planning', isActive: true },

      {
        path: '/PROJECT/ProjectPhases',
        icon: 'fas fa-layer-group',
        title: 'ProjectPhases',
        // permission: 'ProjManagePhases',
        isActive: true
      },
      {
        path: '/PROJECT/ProjectTasks',
        icon: 'fas fa-tasks',
        title: 'ProjectTasks',
        // permission: 'ProjViewTasks',
        isActive: true
      },

      {
        path: '/PROJECT/ProjectBoard',
        icon: 'bi bi-kanban',
        title: 'لوحة المهام',
        isActive: true
      },

      { is_header: true, title: 'Financials', isActive: true },

      {
        path: '/PROJECT/ProjectBudgets',
        icon: 'fas fa-wallet',
        title: 'ProjectBudgets',
        // permission: 'ProjManageBudgets',
        isActive: true
      },
      {
        path: '/PROJECT/ProjectCostItems',
        icon: 'fas fa-dollar-sign',
        title: 'ProjectCostItems',
        // permission: 'ProjManageCosts',
        isActive: true
      },
      {
        path: '/PROJECT/ProjectContracts',
        icon: 'fas fa-file-contract',
        title: 'ProjectContracts',
        // permission: 'ProjManageContracts',
        isActive: true
      },

      { is_header: true, title: 'Tracking & Reports', isActive: true },

      {
        path: '/PROJECT/ProjectTracking',
        icon: 'fas fa-chart-line',
        title: 'ProjectTracking',
        // permission: 'ProjViewTracking',
        isActive: true
      },
      {
        path: '/PROJECT/ProjectIncidents',
        icon: 'fas fa-exclamation-triangle',
        title: 'ProjectIncidents',
        // permission: 'ProjManageIncidents',
        isActive: true
      },

      {
        path: '/PROJECT/ProjectReports',
        icon: 'bi bi-graph-up',
        title: 'التقارير',
        isActive: true
      },

      {
        path: '/PROJECT/Reports',
        icon: 'fas fa-chart-bar',
        title: 'Reports',
        isActive: true
      },
      {
        path: '/PROJECT/Dashboard',
        icon: 'bi bi-graph-up',
        title: 'Dashboard',
        isActive: true
      },

      // { is_header: true, title: 'Project Hub', isActive: true }, // 🆕 قسم جديد

      // {
      //   path: '/PROJECT/project-hub/ORG-1001',
      //   icon: 'fas fa-building',
      //   title: 'مشروع المدرسة - لوحة التحكم',
      //   isActive: true
      // },
      // {
      //   path: '/PROJECT/project-hub/ORG-1002',
      //   icon: 'fas fa-road',
      //   title: 'تأهيل الطرق - لوحة التحكم',
      //   isActive: true
      // },
      // {
      //   path: '/PROJECT/project-hub/ORG-1003',
      //   icon: 'fas fa-warehouse',
      //   title: 'المستودع اللوجستي - لوحة التحكم',
      //   isActive: true
      // }
    ]
  }
];

export default projectMenu;
